import { render, staticRenderFns } from "./PartitionSelection.vue?vue&type=template&id=b1c2e4ea&scoped=true"
import script from "./PartitionSelection.vue?vue&type=script&lang=js"
export * from "./PartitionSelection.vue?vue&type=script&lang=js"
import style0 from "./PartitionSelection.scss?vue&type=style&index=0&id=b1c2e4ea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c2e4ea",
  null
  
)

export default component.exports